import {
  startOfMonth,
  addMonths,
  subMonths,
  endOfMonth,
  startOfWeek,
  addWeeks,
  subWeeks,
  endOfWeek,
  startOfYear,
  addYears,
  subYears,
  endOfYear,
} from 'ag-common/facades'
import CalendarHeaderMonthly from '#components/o/Versetzungsplan/CalendarHeaderMonthly'
import CalendarHeaderWeekly from '#components/o/Versetzungsplan/CalendarHeaderWeekly'
import CalendarHeaderYearly from '#components/o/Versetzungsplan/CalendarHeaderYearly'
import {isSameDay} from 'date-fns'

export const CalendarType = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  DASHBOARD: 'dashboard',
}

const WeeklyCalendarConfig = {
  getInitialDate: () => startOfWeek(new Date()),
  getStartOfCalendar: date => startOfWeek(date),
  getEndOfCalendar: date => endOfWeek(date),
  getNext: date => addWeeks(date, 1),
  getPrevious: date => subWeeks(date, 1),
  getBorderColor: date => '#eaeaea',
  headerComponent: CalendarHeaderWeekly,
}

const MonthlyCalendarConfig = {
  getInitialDate: () => startOfMonth(new Date()),
  getStartOfCalendar: date => startOfWeek(startOfMonth(date)),
  getEndOfCalendar: date => endOfWeek(endOfMonth(date)),
  getNext: date => addMonths(date, 1),
  getPrevious: date => subMonths(date, 1),
  getBorderColor: date => (isSameDay(startOfWeek(date), date) ? '#eaeaea' : 'none'),
  headerComponent: CalendarHeaderMonthly,
}

const YearlyCalendarConfig = {
  getInitialDate: () => startOfYear(new Date()),
  getStartOfCalendar: date => startOfYear(date),
  getEndOfCalendar: date => endOfYear(date),
  getNext: date => addYears(date, 1),
  getPrevious: date => subYears(date, 1),
  getBorderColor: date => (isSameDay(startOfMonth(date), date) ? '#eaeaea' : 'none'),
  headerComponent: CalendarHeaderYearly,
}

const DashboardCalendarConfig = {
  getInitialDate: () => startOfWeek(new Date()),
  getStartOfCalendar: date => startOfWeek(new Date()),
  getEndOfCalendar: date => endOfWeek(addWeeks(startOfWeek(new Date()), 14)),
  getNext: date => addWeeks(date, 14),
  getPrevious: date => subWeeks(date, 14),
  getBorderColor: date => (isSameDay(startOfWeek(date), date) ? '#eaeaea' : 'none'),
  headerComponent: CalendarHeaderMonthly,
}

export const CalendarConfig = {
  [CalendarType.WEEKLY]: WeeklyCalendarConfig,
  [CalendarType.MONTHLY]: MonthlyCalendarConfig,
  [CalendarType.YEARLY]: YearlyCalendarConfig,
  [CalendarType.DASHBOARD]: DashboardCalendarConfig,
}
